/**
 * YLI GA4 Product Interactions Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track product page interactions (wishlist, spool size selection)
 * GA4 Events: wishlist_add, spool_size_select
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // Track which events have been fired
  const trackedEvents = new Set();

  // GA4 Event: wishlist_add
  // Track when users add products to wishlist
  function trackWishlistAdd() {
    // Listen for wishlist button clicks
    document.addEventListener('click', function(e) {
      var wishlistButton = e.target.closest('[data-wishlist-add], [data-add-to-wishlist], .wishlist-add, [class*="wishlist"]');
      if (!wishlistButton) return;

      // Get product details from page
      var productLine = 'Unknown';
      var color = 'Unknown';
      var fromPage = 'product';

      // Try to get product name/line
      var productTitle = document.querySelector('[data-product-title], .product-title, h1[class*="product"]');
      if (productTitle) {
        productLine = productTitle.textContent.trim().split('-')[0].trim();
      }

      // Try to get selected color/variant
      var selectedVariant = document.querySelector('[data-variant-title], .product-variant__title, select[name="id"] option:checked');
      if (selectedVariant) {
        color = selectedVariant.textContent.trim();
      }

      // Determine page type
      if (window.location.pathname.includes('/collections/')) {
        fromPage = 'collection';
      } else if (window.location.pathname.includes('/search')) {
        fromPage = 'search';
      } else if (window.location.pathname.includes('/products/')) {
        fromPage = 'product';
      }

      if (typeof gtag === 'function') {
        gtag('event', 'wishlist_add', {
          'product_line': productLine,
          'color': color,
          'from_page': fromPage
        });
      }
    });
  }

  // GA4 Event: spool_size_select
  // Track when users select different spool sizes
  function trackSpoolSizeSelect() {
    // Listen for variant selection changes
    var variantSelectors = document.querySelectorAll('[name="id"], [data-variant-selector], select[id*="variant"]');

    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        var variantTitle = selectedOption.textContent.trim();

        // Check if this is a size selection (contains yard/yd or cone)
        if (!variantTitle.toLowerCase().includes('yd') &&
            !variantTitle.toLowerCase().includes('yard') &&
            !variantTitle.toLowerCase().includes('cone')) {
          return; // Not a size selector
        }

        // Extract size
        var size = 'Unknown';
        if (variantTitle.includes('500') && variantTitle.toLowerCase().includes('yd')) {
          size = '500yd';
        } else if (variantTitle.includes('1000') && variantTitle.toLowerCase().includes('yd')) {
          size = '1000yd';
        } else if (variantTitle.includes('2000') && variantTitle.toLowerCase().includes('yd')) {
          size = '2000yd';
        } else if (variantTitle.toLowerCase().includes('cone')) {
          size = 'cone';
        }

        // Check if price comparison is visible
        var priceCompareViewed = 'no';
        var priceElements = document.querySelectorAll('[data-price], .product-price, [class*="price"]');
        if (priceElements.length > 1) {
          priceCompareViewed = 'yes'; // Multiple prices visible suggests comparison
        }

        if (typeof gtag === 'function') {
          gtag('event', 'spool_size_select', {
            'size': size,
            'price_compare_viewed': priceCompareViewed
          });
        }
      });
    });

    // Also listen for custom variant change events (if theme uses them)
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        var variant = e.detail.variant;
        var variantTitle = variant.title || variant.name || '';

        // Check if this is a size selection
        if (!variantTitle.toLowerCase().includes('yd') &&
            !variantTitle.toLowerCase().includes('yard') &&
            !variantTitle.toLowerCase().includes('cone')) {
          return;
        }

        var size = 'Unknown';
        if (variantTitle.includes('500')) size = '500yd';
        else if (variantTitle.includes('1000')) size = '1000yd';
        else if (variantTitle.includes('2000')) size = '2000yd';
        else if (variantTitle.toLowerCase().includes('cone')) size = 'cone';

        var priceCompareViewed = document.querySelectorAll('[data-price], .product-price').length > 1 ? 'yes' : 'no';

        if (typeof gtag === 'function') {
          gtag('event', 'spool_size_select', {
            'size': size,
            'price_compare_viewed': priceCompareViewed
          });
        }
      }
    });
  }

  // Initialize tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackWishlistAdd();
      trackSpoolSizeSelect();
    });
  } else {
    trackWishlistAdd();
    trackSpoolSizeSelect();
  }

})();
